export const getFrequentMemberItem = (dataArray) => {
    const emptyArray = new Array(4).fill('');
    return `
                ${getListItem(dataArray, 0)}
                <li class="list-box-ul">
                    <ul class="list-box-container">
                        ${emptyArray.map((v, i) => getListItem(dataArray, i + 1)).join('')}
                    </ul>
                </li>
            `
}

const getListItem = (array, index) => {
    const isExist = array.length > index
    const isFirst = index === 0;
    const data = isExist && array[index]
    const defaultURl = "/flow-renewal/assets/images/profile-default.svg";

    return `
        <li class="js-member-item ${isFirst ? 'list-box-ul-one' : 'two-five'}"
            data-user-id="${data.USER_ID?? ''}">
            <div class="rank ${isFirst ? 'one' : ''}">${isFirst? '' : index + 1}</div>
                ${data ? `
                <div class="rank-img ${isFirst ? 'one' : ''}">
                    <img ${ListHelper.setSrc(ImageUtil.removeDomain("PROFILE", data.PRFL_PHTG), defaultURl)} alt="profile" class="profile-image">
                </div>
                <div class="rank-cont ${isFirst ? 'one' : ''}">
                    <div class="top name">${Mutil.n2v(data.FLNM)}</div>
                    <div class="bottom d-block">${Mutil.n2v(data.JBCL_NM)}</div>
                </div>` : `<div class="rank-no-data">${i18next.t(common.noData)}</div>`}
        </li>`
}
